import { Injectable, EventEmitter, TemplateRef } from '@angular/core';

import { TipoUrlEnum, TipoPopUpEnum } from '../utilidades.index';
import { RespuestaModel, PopUpModel, MenuItemModel } from '../utilidades.modelos.index';
import { PopUpComponent } from '../utilidades.componentes.index';

import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { observable, Observable } from 'rxjs';
import { catchError, filter, map } from "rxjs/operators";
import { JwtHelperService } from '@auth0/angular-jwt';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { Router, NavigationExtras } from '@angular/router';
import { MD5, WordArray, SHA1, SHA256, SHA512 } from "crypto-js";
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})
export class UtilidadesService {

	public _menu: MenuItemModel[] = [];
	public _menuAbierto: boolean = false;
	public _menuActualizado: EventEmitter<any> = new EventEmitter();
	public _modoMenu: string = "";
	public _mostrarCargando: boolean = false;
	public _titulo: string = "";

	get Menu(): MenuItemModel[] {
		return this._menu;
	}
	set Menu(value: MenuItemModel[]) {
		this._menu = value;
		this._menuActualizado.emit();
	}

	constructor(
		private _dialog: MatDialog,
		private _http: HttpClient,
		private _router: Router
	) { }

	//Busca un permiso en la lista.
	public BuscarPermiso(estado: string, lista: MenuItemModel[]): MenuItemModel {
		let PermisoEncontrado = null;

		if (lista != undefined && lista != null) {
			//Busco en cada elemento de la lista.
			lista.forEach(item => {
				//Primero verifico si ya encontro algo anteriormente.
				if (PermisoEncontrado == null) {
					//Primero verifico si el nombre coiside.
					if (item.Estado == estado) {
						PermisoEncontrado = item;
					}
					else {
						//Si tiene submenu y no coinside la busqueda, busco en el submenu.
						if (item.SubMenu != undefined && item.SubMenu != null) {
							if (item.SubMenu.length > 0) {
								PermisoEncontrado = this.BuscarPermiso(estado, item.SubMenu);
							}
						}
					}
				}
			});
		}

		return PermisoEncontrado;
	}

	public BorrarToken(): void {
		window.localStorage.removeItem("AyC_Token");
	}

	public CargarMenu() {
		this.Get("Administracion/API/Sistemas/Menu/" + environment.IdSistema, TipoUrlEnum.Absoluta).subscribe(Rta => this.Menu = <MenuItemModel[]>Rta);
	}

	public CerrarSesion(): void {
		this.RedireccionarAInicioDeSesion(false);
	}

	public ControlarError(error: HttpErrorResponse): Observable<RespuestaModel> {
		console.log('error');
		let Rta = new RespuestaModel();

		if (error.status) {
			switch (error.status.toString()) {
				case "400":
					Rta.Error.push(error.statusText);
					break;

				case "401":
					Rta.Error.push("No tiene permisos para acceder a " + error.url);
					break;

				case "404":
					Rta.Error.push("No se encuentra " + error.url)
					break;

				case "500":
					Rta.Error.push("Error de servidor. " + error.statusText)
					break;

				default:
					Rta.Error.push(error.statusText);
					break;
			}
		}
		else {
			if (error.message) {
				Rta.Error.push(error.message);
			}
		}

		return Observable.create(ob => {
			this._mostrarCargando = false;

			if (environment.Debug) {
				console.log("Controlando error http");
			}

			this._mostrarCargando = false;

			ob.next(Rta);
		});
	}

	public ConvertirAHex(texto: string): string {
		var Hex, I;
		var Rta: string = "";

		for (I = 0; I < texto.length; I++) {
			Hex = texto.charCodeAt(I).toString(16);
			Rta += Hex;
		}

		return Rta;
	}

	public ConvertirDeHex(texto: string): string {
		var J;
		var Hexes = texto.match(/.{1,2}/g) || [];

		var Rta: string = "";
		for (J = 0; J < Hexes.length; J++) {
			Rta += String.fromCharCode(parseInt(Hexes[J], 16));
		}

		return Rta;
	}

	public CuadroDeConfirmacion(titulo: string, pregunta: string, siClick, noClick = undefined, siLabel = "Aceptar", noLabel = "Cancelar") {
		let Info = new PopUpModel();
		Info.Titulo = titulo;
		Info.Mensaje = [pregunta];
		Info.SiClick = siClick;
		Info.NoClick = noClick;
		Info.TipoDePopUp = TipoPopUpEnum.Confirmacion;
		Info.SiLabel = siLabel;
		Info.NoLabel = noLabel;
		Info.MostrarBotonCerrar = false;

		this._dialog.open(PopUpComponent, {
			data: Info
		});
	}

	public CuadroDeComponente(componente: ComponentType<any>, datos: any = null) {
		return this._dialog.open(componente, { data: datos });
	}

	public CuadroDeIFrame(url: string, ancho: number = 700, alto: number = 500) {
		let Info = new PopUpModel();
		Info.Alto = alto;
		Info.Ancho = ancho;
		Info.Url = url;
		Info.TipoDePopUp = TipoPopUpEnum.IFrame;
		Info.MostrarBotonCerrar = true;

		this._dialog.open(PopUpComponent, {
			data: Info
		});
	}

	public CuadroDeImagen(url: string) {
		let Info = new PopUpModel();
		Info.Url = url;
		Info.MostrarBotonCerrar = true;
		Info.TipoDePopUp = TipoPopUpEnum.Imagen;
		Info.MostrarBotonCerrar = true;

		this._dialog.open(PopUpComponent, {
			data: Info
		});
	}

	public CuadroDeMensaje(titulo: string, error: string[], onClick = undefined, labelAceptar = "Aceptar") {
		let Info = new PopUpModel();
		Info.Titulo = titulo;
		Info.Mensaje = error;
		Info.SiClick = onClick;
		Info.SiLabel = labelAceptar;
		Info.TipoDePopUp = TipoPopUpEnum.Mensaje;
		Info.MostrarBotonCerrar = false;

		this._dialog.open(PopUpComponent, {
			data: Info
		});
	}

	public CuadroHTML(elemento: TemplateRef<any>, ancho: string = null, alto: string = null): MatDialogRef<any, any> {
		let Datos: any = {};

		if (ancho) {
			Datos.width = ancho;
		}

		if (alto) {
			Datos.height = alto;
		}

		return this._dialog.open(elemento, Datos);
	}

	public Get(url: string, tipoUrl: TipoUrlEnum = TipoUrlEnum.Relativa): Observable<any> {
		let Url = '';

		switch (tipoUrl) {
			case TipoUrlEnum.Relativa:
				Url = environment.UrlBase + url;
				break;

			case TipoUrlEnum.Absoluta:
				Url = environment.UrlRoot + url;
				break;

			case TipoUrlEnum.Externa:
				Url = url;
				break;
		}

		if (environment.Debug) {
			console.log('GET: ' + Url);
		}

		this._mostrarCargando = true;

		return this._http.get<RespuestaModel>(Url, { headers: this.ObtenerEncabezados() })
			.pipe(
				//Capturo el error en caso que ocurra.
				catchError(this.ControlarError),

				//Filtro las llamadas que no tienen mensaje de error desde el servidor.
				filter((resp: RespuestaModel, index) => {
					this._mostrarCargando = false;

					if (environment.Debug) {
						console.log("Filtrando llamada http");
					}

					if (resp.CantidadDeErrores == 0) {
						return true;
					}
					else {
						this.CuadroDeMensaje("Error!", resp.Error);
						return false;
					}
				}),

				//Modifico la salida para sólo devolver el objeto que necesito que es la propiedad resultado.
				map((x: RespuestaModel) => {
					//Guardo el nuevo token.
					this.GuardarToken(x.Token);

					//Oculto el cargando.
					this._mostrarCargando = false;

					//Devuelvo sólo lo importante de la respuesta.
					return x.Resultado;
				})
			);
	}

	public GetArchivo(url: string, desdeRaiz: boolean = false, nombreDeArchivo: string = "Archivo.pdf", tipoArchivo: string = "application/pdf"): Observable<any> {
		let Url = '';

		if (desdeRaiz) {
			Url = environment.UrlRoot + url;
		} else {
			Url = environment.UrlBase + url;
		}

		if (environment.Debug) {
			console.log(`GET: ${Url}`);
		}

		return this._http.get(Url, { headers: this.ObtenerEncabezados(), responseType: 'blob' })
			.pipe(map(x => {
				return this.DescargarArchivo(x, tipoArchivo, nombreDeArchivo);
			}), catchError(this.ControlarError));
	}

	//Guarda el token en el localStorage.
	public GuardarToken(token: string): void {

		if (environment.Debug) {
			console.log("Guardando nuevo token: ", token);
		}

		if (token) {
			//Busco el token guardado.
			var TokenGuardado = this.ObtenerTokenPayload();
			const JwtHelper = new JwtHelperService();

			//Si lo que está guardado es nulo, guardo el token nuevo.
			if (TokenGuardado == null) {
				window.localStorage.setItem("AyC_Token", token);
			}
			else {
				//Obtengo el payload del nuevo token.
				var NuevoToken = JwtHelper.decodeToken(token);

				//Si el IdUsuario distinto de 0 lo guardo, sino dejo el token guardado.
				if (NuevoToken.idUsuario != 0) {
					window.localStorage.setItem("AyC_Token", token);
				}
			}
		}
	}

	public DescargarArchivo(datos: Blob, tipo: string, nombreDeArchivo: string): string {
		var blob = new Blob([datos], {
			type: tipo
		});
		var url = window.URL.createObjectURL(blob);

		return url;
	}

	public DescargarArchivoTxt(contenido: string, nombreDeArchivo: string = "Archivo"): void {
		//Creo un elemento oculto
		const a = document.createElement('a');
		a.setAttribute('style', 'display:none;');
		document.body.appendChild(a);

		//Creo un archivo y lo agrego el elemento oculto
		a.href = this.DescargarArchivo(new Blob([contenido]), "text/plain", "");
		a.download = nombreDeArchivo + ".txt";
		a.name = nombreDeArchivo + ".txt";
		a.click();
	}

	public Encriptar(texto: string, algoritmo: string = "MD5"): string {
		let Encriptado: WordArray;

		if (algoritmo === "MD5") {
			Encriptado = MD5(texto);
		} else if (algoritmo === "SHA-1") {
			Encriptado = SHA1(texto);
		} else if (algoritmo === "SHA-2-256") {
			Encriptado = SHA256(texto);
		} else if (algoritmo === "SHA-2-512") {
			Encriptado = SHA512(texto);
		} else {
			throw Error("El tipo de algoritmo no es válido:" + algoritmo);
		}

		return Encriptado.toString(CryptoJS.enc.Base64);
	}

	get EsDebug(): boolean {
		return environment.Debug;
	}

	//Determina si el dispositivo en el cual estoy navegando es un dispositivo móvil o no.
	public EsMovil(): boolean {
		if (navigator.userAgent.match(/Android/i)
			|| navigator.userAgent.match(/webOS/i)
			|| navigator.userAgent.match(/iPhone/i)
			|| navigator.userAgent.match(/iPad/i)
			|| navigator.userAgent.match(/iPod/i)
			|| navigator.userAgent.match(/BlackBerry/i)
			|| navigator.userAgent.match(/Windows Phone/i)
			|| navigator.userAgent.match(/IEMobile/i)
			|| navigator.userAgent.match(/WPDesktop/i)
			|| window.innerWidth <= 800
		) {
			return true;
		}
		else {
			return false;
		}
	}

	public Fecha_ddMMyyyy(fecha: Date): string {
		let Dia = fecha.getDate();
		let Mes = fecha.getMonth() + 1;
		let Anio = fecha.getFullYear();

		let DiaStr = Dia.toString();
		let MesStr = Mes.toString();

		if (Dia < 10) {
			DiaStr = '0' + Dia.toString();
		}
		if (Mes < 10) {
			MesStr = '0' + Mes.toString();
		}
		return `${DiaStr}/${MesStr}/${Anio.toString()}`;
	}

	public FechaANumero(fecha: Date): number {
		if (fecha) {
			let Fecha: Date = new Date(fecha);

			//let Anio = Fecha.getFullYear();			//*10000000000
			//let Mes = Fecha.getMonth() + 1;			//*100000000
			//let Dia = Fecha.getDate();				//*1000000
			//let Horas = Fecha.getHours();			//*10000
			//let Minutos = Fecha.getMinutes();		//*100
			//let Segundos = Fecha.getSeconds();		//*1

			return (Fecha.getFullYear() * 10000000000) + ((Fecha.getMonth() + 1) * 100000000) + (Fecha.getDate() * 1000000) + (Fecha.getHours() * 10000) + (Fecha.getMinutes() * 100) + Fecha.getSeconds();
		}
		else {
			return 0;
		}
	}

	public FormularioAObjeto(formulario: FormData): any {
		let Objeto: any = {};

		formulario.forEach(function (value, key) {
			Objeto[key] = value;
		});

		return Objeto;
	}

	public ImagenDePerfil(): Observable<Blob> {
		let Payload = this.ObtenerTokenPayload();

		if (Payload) {
			return this._http.get(environment.UrlRoot + "Administracion/API/Usuarios/" + Payload.IdUsuario + "/Imagen", { headers: this.ObtenerEncabezados(), responseType: "blob" });
		}
		else {
			return new Observable<Blob>();
		}
	}

	public IniciarAplicacion(): void {
		//var Token = this.ObtenerToken();
		//var IniciarSesion = true;
		//let JwtHelper = new JwtHelperService();

		////Verifico que el LocalStorage no sea nulo.
		//if (Token) {
		//	//Verifico si el token no expiro.
		//	if (!(JwtHelper.isTokenExpired(Token))) {
		//		IniciarSesion = false;
		//	}
		//}

		//if (IniciarSesion) {
		//	if (!(environment.Debug)) {
		//		this.RedireccionarAInicioDeSesion(true);
		//	}
		//}
		//else {
			//this.CargarMenu();
		//}

		//Determino como se va a visualizar el menu.
		if (this.EsMovil()) {
			this._modoMenu = "over";
		}
		else {
			this._modoMenu = "side";
			//this._menuAbierto = true;
		}
	}

	public Navegar(url: any[], extras?: NavigationExtras) {
		this._router.navigate(url, extras);
	}

	private ObtenerEncabezados(): HttpHeaders {
		return new HttpHeaders({
			"Content-Type": "application/json",
			"AyC_Token": this.ObtenerToken()
		});
	}

	public ObtenerToken(): string {
		if (localStorage.getItem("AyC_Token")) {
			return localStorage.getItem("AyC_Token");
		}
		else {
			return "";
		}
	}

	//Obtengo la info del token.
	public ObtenerTokenPayload() {
		const JwtHelper = new JwtHelperService();
		let TokenGuardado = this.ObtenerToken();

		//Verifico que el token guardado sea distinto de nulo.
		if (TokenGuardado != null) {
			//Verifico que sea distinto de vacío.
			if (TokenGuardado != "") {
				//Devuelvo el payload del token.
				return JwtHelper.decodeToken(TokenGuardado);
			}
		}

		//Si llega aca es porque no existe y devuelvo nulo.
		return null;
	}

	public Post(url: string, cuerpo: any, tipoUrl: TipoUrlEnum = TipoUrlEnum.Relativa): Observable<any> {
		let Url = '';

		switch (tipoUrl) {
			case TipoUrlEnum.Relativa:
				Url = environment.UrlBase + url;
				break;

			case TipoUrlEnum.Absoluta:
				Url = environment.UrlRoot + url;
				break;

			case TipoUrlEnum.Externa:
				Url = url;
				break;
		}

		if (environment.Debug) {
			console.log(`POST: ${Url} => ${JSON.stringify(cuerpo)}`);
		}

		this._mostrarCargando = true;

		return new Observable<any>(observer => {
			this._http.post<RespuestaModel>(Url, cuerpo, { headers: this.ObtenerEncabezados() })
			.pipe(
				//Capturo el error en caso que ocurra.
				// catchError(this.ControlarError),

				//Filtro las llamadas que no tienen mensaje de error desde el servidor.
				// filter((resp: RespuestaModel, index) => {
				// 	this._mostrarCargando = false;

				// 	if (environment.Debug) {
				// 		console.log("Filtrando llamada http");
				// 	}

				// 	if (resp.CantidadDeErrores == 0) {
				// 		return true;
				// 	}
				// 	else {
				// 		this.CuadroDeMensaje("Error!", resp.Error);
				// 		return false;
				// 	}
				// }),

				//Modifico la salida para sólo devolver el objeto que necesito que es la propiedad resultado.
				map((response: RespuestaModel) => {

					this._mostrarCargando = false;

					if (environment.Debug) {
						console.log("Filtrando llamada http");
					}

					if (response.CantidadDeErrores > 0)
						this.CuadroDeMensaje("Error!", response.Error);

					//Guardo el nuevo token.
					this.GuardarToken(response.Token);

					//Oculto el cargando.
					this._mostrarCargando = false;

					//Devuelvo sólo lo importante de la respuesta.
					return response.Resultado;
				})
			)
			.subscribe(
				(result: any) => {
					observer.next(result);
				},
				error => {
					observer.error(error);
				},
				() => {
					observer.complete();
				}
			);
		});
	}

	public PostFormulario(url: string, formulario: FormData, desdeRaiz: boolean = false): Observable<RespuestaModel> {
		return Observable.create(objeto => {
			//Instancio XHR.
			let XHR = new XMLHttpRequest();
			XHR.responseType = 'json';
			let Rta: RespuestaModel = new RespuestaModel();

			let Url = '';

			if (desdeRaiz) {
				Url = environment.UrlRoot + url;
			} else {
				Url = environment.UrlBase + url;
			}

			//Ejecuto cada vez que cambia el estado.
			XHR.onreadystatechange = () => {
				/*
					0	UNSENT				Client has been created. open() not called yet.
					1	OPENED				open() has been called.
					2	HEADERS_RECEIVED	send() has been called, and headers and status are available.
					3	LOADING				Downloading; responseText holds partial data.
					4	DONE				The operation is complete.
				*/

				//Si el estado es 4
				if (XHR.readyState === 4) {
					switch (XHR.status) {
						case 200:
							Rta = (<RespuestaModel>XHR.response);
							objeto.next(Rta);
							break;

						case 404:
							Rta.Error.push("- \"" + Url + "\" no existe.");
							break;

						case 401:
							Rta.Error.push("- No tiene permisos para subir el archivo.");
							break;

						default:
							Rta.Error.push(XHR.statusText);
							break;
					}

				}
			};

			// Emit current progress in percents
			//XHR.upload.onprogress = (event: ProgressEvent) => {
			//	this._progreso.next(Math.round((event.loaded / event.total) * 100));
			//};

			if (environment.Debug) {
				console.log(`POST FORMULARIO: ${Url} => ${JSON.stringify(this.FormularioAObjeto(formulario))}`);
			}

			XHR.open('POST', Url, true);
			XHR.setRequestHeader("AyC_Token", this.ObtenerToken());
			XHR.send(formulario);
		});
	}

	public RedireccionarAInicioDeSesion(guardarUrl: boolean = true): void {
		let Url = environment.UrlIniciarSesion;

		if (guardarUrl) {
			Url += "?url=" + this.ConvertirAHex(window.location.href);
		}

		window.location.href = Url;
	}

	//Determina si existe o no un permiso.
	public TienePermiso(permiso: string): boolean {
		return this.BuscarPermiso(permiso, this.Menu) != null;
	}

	//Determina si el token es válido o no.
	public TokenValido(): boolean {
		const JwtHelper = new JwtHelperService();
		let TokenGuardado = this.ObtenerToken();

		//Verifico que el token guardado sea distinto de nulo.
		if (TokenGuardado) {
			//Devuelvo el payload del token.
			return (JwtHelper.decodeToken(TokenGuardado) ? true : false);
		}
		else {
			return false;
		}
	}
}